import memoizeOne from 'memoize-one'
import isDeepEqual from 'lodash.isequal'

import {globalColumnDefinition} from '../../../common/AgGrid/AgGridColumn'

export const myAccountsIntialise = () => {
	return {
		accountId: '',
		accountType: '',
		id: '',
		portfolioId: 0,
		name: '',
		tenantId: '',
	}
}

export const getColumns = memoizeOne((isWritePermission, setFormData) => {
	return [
		Object.assign({}, globalColumnDefinition.name, {
			headerName: 'Account Name',
			onCellClicked: params => {
				isWritePermission && setFormData(params.data)
			},
			cellClass: [isWritePermission ? 'cursor-pointer text-link' : ''],
		}),
		globalColumnDefinition.accountType,
		globalColumnDefinition.portfolioFullName,
	]
}, isDeepEqual)

export const isFormValidFn = myAccounts => {
	const {name, portfolioId} = myAccounts
	return name && name.trim() && portfolioId > 0
}

export const sortAccountsDataById = (data: any[]) => {
	data.sort((a, b) => {
		let aid = a.id
		let bid = b.id
		return aid - bid
	})
}
